import { Component, Inject, OnInit, inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ConfirmUserSafeIPsCommand } from "src/app/core/api/models";
import { EventTypes } from "src/app/core/constants/event-types";
import { ConsoleService } from "src/app/core/services/console.service";
import { CreateUserSafeIPsCommand } from "../../../../../core/api/models/create-user-safe-i-ps-command";
import { UserSafeIPsService } from "../../../../../core/api/services/user-safe-i-ps.service";
import { BaseFormPageComponent } from "../../../../shared/base/components/base-form-page.component";
import { BaseFormModule } from "src/app/pages/shared/base/modules/base-form.module";
import { ModalTitleComponent } from "../../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: "app-confirm-user-safe-ips-form",
    templateUrl: "./confirm-user-safe-ips-form.component.html",
    imports: [BaseFormModule, ModalTitleComponent]
})
export class ConfirmUserSafeIpsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: ConfirmUserSafeIPsCommand = {};
  protected currentService = inject(UserSafeIPsService);

  //#endregion

  constructor(
    private dialogRef: MatDialogRef<ConfirmUserSafeIpsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.model.id = data?.id;
    this.model.useToCreateToken = data?.useToCreateToken;
    this.model.useToLoginPanel = data?.useToLoginPanel;
  }

  ngOnInit() {
    this.initForm();
    this.initModel();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      isConfirmed: new FormControl(""),
      useToCreateToken: new FormControl(""),
      useToLoginPanel: new FormControl(""),
    });
  }

  //#region Api

  //confirm and not confirm
  confirmUserSafeIpsApi(model: CreateUserSafeIPsCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .userSafeIPsConfirmUserSafeIps({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#region final methods

  onSubmit() {
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;

    try {
      this.confirmUserSafeIpsApi(this.model);
    } catch (error) {
      ConsoleService.error("error", error);
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion
}
